import { render, staticRenderFns } from "./editNote.vue?vue&type=template&id=88bd7080&"
import script from "./editNote.vue?vue&type=script&lang=js&"
export * from "./editNote.vue?vue&type=script&lang=js&"
import style0 from "./editNote.vue?vue&type=style&index=0&id=88bd7080&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports